/* eslint-disable react/no-unused-state */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import '../../styles/containers/Party.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormControl } from 'react-bootstrap';
import { FilterPanel } from '../utils/FilterPanel';
import {
  StyledFilterFormGroup,
  StyledFilterTitle,
  StyledFilterWrapper,
} from '../utils/Styles/FilterStyles';

class FilteredData {
  name = '';
  type = '';
}

class State {
  filteredData = new FilteredData();
  filter = 'ALL';
  isSuccsess = false;
  isError = false;
  isDeactive = false;
}

export default class FilterTagForm extends React.Component {
  filters = [
    { label: 'All Types', name: 'ALL' },
    { label: 'normal', name: 'NORMAL' },
    { label: 'marketplace filter', name: 'FILTER' },
    { label: 'additional booking info', name: 'ADDITIONAL' },
    { label: 'hidden', name: 'HIDDEN' },
  ];

  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterData } = this.props;
    if (filterData) {
      this.setState({ filteredData: filterData });
    }
  }

  componentWillUnmount() {
    this.setState({ isDeactive: true });
  }

  hideMessage = () => {
    const { isDeactive } = this.state;
    if (!isDeactive) {
      this.setState({ isError: false });
    }
  };

  handleNameChange = ({ target }) => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      name: target.value,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  changeFilter = filter => {
    let { filteredData } = this.state;
    switch (filter) {
      case 'NORMAL': {
        filteredData = {
          ...filteredData,
          type: 'normal',
        };
        break;
      }
      case 'FILTER': {
        filteredData = {
          ...filteredData,
          type: 'marketplace filter',
        };
        break;
      }
      case 'ADDITIONAL': {
        filteredData = {
          ...filteredData,
          type: 'additional booking info',
        };
        break;
      }
      case 'HIDDEN': {
        filteredData = {
          ...filteredData,
          type: 'hidden',
        };
        break;
      }
      default: {
        filteredData = {
          ...filteredData,
          type: '',
        };
        this.setState({ filteredData, filter });
      }
    }
    this.setState({ filteredData, filter });
    this.handleSubmit(filteredData);
  };

  handleSubmit = async filteredData => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterTags } = this.props;
    filterTags(filteredData);
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { isMobileFilterSelected } = this.props;
    const { filteredData, filter } = this.state;
    return (
      <Fragment>
        <div
          className={`form-content horizontal-form filter-form ${
            isMobileFilterSelected ? 'mobile-filter-selected' : ''
          }`}
          style={{ paddingLeft: '0px' }}
        >
          <StyledFilterTitle>Filters</StyledFilterTitle>
          <StyledFilterWrapper>
            <FilterPanel
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              filters={this.filters}
              currentFilter={filter}
              onFilterChange={this.changeFilter}
            />
            <StyledFilterFormGroup>
              <FormControl
                type='text'
                placeholder='Name'
                onChange={this.handleNameChange}
                value={filteredData.name}
              />
            </StyledFilterFormGroup>
          </StyledFilterWrapper>
        </div>
      </Fragment>
    );
  }
}
